/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useCallback }  from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { Navigate, Route, Routes, Outlet } from "react-router-dom";

import { IRoute } from "../types/RouteType";
import { 
    routes as dashboardRoutes, 
} from "./index";
import { MainLayout, AuthLayout, ChangePasswordLayout } from "../layouts";
import { RootState } from '../redux/store/store';
import SignIn from "../pages/security/authentication/signin";
import ChangePassword from "../pages/security/authentication/changePassword";
import { Refresh } from '../redux/actionCreators/authActions';


export const ModifiedMainLayout = () => {
    return (
        <MainLayout>
            <Outlet />  
        </MainLayout>
    )
    };
    
const ModifiedAuthLayout = () => {
    return (
        <AuthLayout>
            <Outlet />  
        </AuthLayout>
    )
};

const ModifiedChangePasswordLayout = () => {
    return (
        <ChangePasswordLayout>
            <Outlet />  
        </ChangePasswordLayout>
    )
};

const AppRoutes: FC<AppRoutesProps> = ({ token, isPasswordChanged }) => {
    const dispatch = useDispatch()
    const refresh = useCallback(() => {    
            dispatch<any>(Refresh());
        }, [dispatch])

    if(token === null || token === ''){
        refresh()
    }

    const authToken = sessionStorage.getItem("token")
    const isAuthenticated = authToken !== null && authToken !== '' 
    console.log('+++isAuthenticated: ', isAuthenticated)

    return (
        <>
        {isAuthenticated ?
            (isPasswordChanged ?
                <Routes>
                    <Route element={<ModifiedChangePasswordLayout/>}>
                        <Route
                            path={'/auth/changepassword'}
                            element={<ChangePassword />}
                        />
                    </Route>
                    <Route
                        path={'/'}
                        element={<Navigate to='/auth/changepassword' replace={true}/>}
                    />
                </Routes>
            :
                <Routes>
                    <Route element={<ModifiedMainLayout/>}>
                    {dashboardRoutes.map((route: IRoute) => (
                        // route.path === '/' 
                        // ?
                        // <Route
                        //     key={route.key}
                        //     path={route.path}
                        //     element={<route.component />}
                        // />
                        // :
                        <Route
                            key={route.key}
                            path={route.path}
                            element={<route.component />}
                        />        
                    ))}
                        <Route
                            path={'/auth/404'}
                            element={<Navigate to='/auth/page404' replace={true}/>}
                        />   
                        <Route
                            path={'/auth/*'}
                            element={<Navigate to='/' replace={true}/>}
                        />   
                    </Route>
                </Routes>
            )
            :
            <Routes>
                <Route element={<ModifiedAuthLayout/>}>
                {/* {authRoutes.map((route: IRoute) => ( */}
                    <Route
                        path={'/auth/sign-in'}
                        element={<SignIn />}
                    />
                {/* ))} */}
                </Route>
                <Route
                    path={'/'}
                    element={<Navigate to='/auth/sign-in' replace={true}/>}
                />
            </Routes>
        }   
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    token: state.auth.authToken,
    isPasswordChanged: state.auth.isPasswordChanged,
});

const mapDispatchToProps = () => ({
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type AppRoutesProps = ConnectedProps<typeof connector>;

export default connector(AppRoutes)
